<template>
  <div>
    <el-dialog
      :title="isEdit ? '编辑提现配置' : '创建提现配置'"
      :visible.sync="visible"
      width="900px"
      :close-on-click-modal="false"
      @close="handleClose"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="150px"
      >
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" placeholder="请输入标题" style="width: 60%;" clearable />
        </el-form-item>
        <el-form-item label="获得金币" prop="config_result.coin">
          <el-input-number
            v-model="form.config_result.coin"
            :min="0"
            :precision="0"
            controls-position="right"
            style="width: 60%;"
          />
        </el-form-item>
        <el-form-item label="递减比例（%）" prop="config_result.decrease_start">
          <el-input-number
            v-model="form.config_result.decrease_start"
            :min="0"
            :max="100"
            :precision="0"
            controls-position="right"
            style="width: 160px;"
          />
          <span style="margin: 0 10px;">到</span>
          <el-input-number
            v-model="form.config_result.decrease_end"
            :min="0"
            :max="100"
            :precision="0"
            controls-position="right"
            style="width: 160px;"
          />
        </el-form-item>
        <el-form-item label="汇率" prop="config_result.exchange_rate">
          <span class="unit-tip">1元 = </span>
          <el-input-number
            v-model="form.config_result.exchange_rate"
            :min="0"
            controls-position="right"
            style="width: 60%;"
          />
          <span class="unit-tip">金币</span>
          <!-- <span class="unit-tip">金额（元）：{{ yuanDisplay(form.config_result.exchange_rate) }}</span> -->
          <!-- <span class="unit-tip">100金币 = {{ form.config_result.exchange_rate }}元</span> -->
        </el-form-item>
        <el-form-item label="可提现规则" prop="config_result.withdrawal_rules">
          <div class="withdrawal-list">
            <div
              v-for="(item, index) in form.config_result.withdrawal_rules"
              :key="index"
              class="withdrawal-rule-item"
            >
              <div class="withdrawal-rule-row">
                <span class="rule-label">天数</span>
                <el-input-number
                  v-model="item.many_day"
                  :min="1"
                  :precision="0"
                  controls-position="right"
                  style="width: 140px;"
                />
                <span class="rule-label">次数</span>
                <el-input-number
                  v-model="item.many_day_number"
                  :min="1"
                  :precision="0"
                  controls-position="right"
                  style="width: 140px;"
                />
                <span class="rule-label">提现金额（元）</span>
                <el-input-number
                  v-model="item.withdrawal_amount"
                  :min="0"
                  :precision="0"
                  controls-position="right"
                  style="width: 160px;"
                />
                <el-button
                  type="danger"
                  size="mini"
                  icon="el-icon-delete"
                  :disabled="form.config_result.withdrawal_rules.length <= 1"
                  @click="removeWithdrawalRule(index)"
                />
              </div>
            </div>
          </div>
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addWithdrawalRule">增加一项</el-button>
        </el-form-item>
        <el-form-item label="小程序">
          <div>
            <el-tag
              v-if="wechatid"
              style="margin-right:10px"
            >{{ wechatname }}</el-tag>
            <el-button
              type="primary"
              size="mini"
              :disabled="isEdit"
              @click="choosewecaht"
            >选择小程序</el-button>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="选择绑定的小程序"
      :visible.sync="dialogVisiblewechat"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="50%"
    >
      <chhosewechat
        ref="chhosewecahtr"
        @callback="callback"
      />
    </el-dialog>
  </div>

</template>

<script>
import { adRedPacketWithdrawConfigCreate, adRedPacketWithdrawConfigUpdate } from '@/api/bserw'
import chhosewechat from './chhosewechat.vue'
export default {
  name: 'WithdrawDialog',
  components: { chhosewechat },
  data() {
    return {
      dialogVisiblewechat: false,
      visible: false,
      submitting: false,
      isEdit: false,
      editId: null,
      wechatid: null,
      wechatname: '',
      form: {
        title: '',
        // 这里的金额单位统一使用「元」，提交时再转换为「分」给后端
        config_result: {
          coin: 10,
          decrease_start: 10,
          decrease_end: 20,
          exchange_rate: 1000,
          withdrawal_rules: [
            { many_day: 7, many_day_number: 1, withdrawal_amount: 1 }
          ]
        }
      },
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        'config_result.coin': [{ required: true, message: '请输入获得金币', trigger: 'change' }],
        'config_result.decrease_start': [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value === '' || value === null || value === undefined) {
                callback(new Error('请输入递减比例开始'))
                return
              }
              const num = Number(value)
              if (!Number.isInteger(num) || num < 0 || num > 100) {
                callback(new Error('递减比例开始必须是 0-100 的整数'))
                return
              }
              callback()
            },
            trigger: 'change'
          }
        ],
        'config_result.decrease_end': [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value === '' || value === null || value === undefined) {
                callback(new Error('请输入递减比例结束'))
                return
              }
              const num = Number(value)
              if (!Number.isInteger(num) || num < 0 || num > 100) {
                callback(new Error('递减比例结束必须是 0-100 的整数'))
                return
              }
              if (this.form && this.form.config_result && this.form.config_result.decrease_start !== '' && this.form.config_result.decrease_start !== null) {
                const start = Number(this.form.config_result.decrease_start)
                if (num < start) {
                  callback(new Error('结束值不能小于开始值'))
                  return
                }
              }
              callback()
            },
            trigger: 'change'
          }
        ],
        'config_result.exchange_rate': [{ required: true, message: '请输入汇率', trigger: 'change' }],
        'config_result.withdrawal_rules': [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || !Array.isArray(value) || value.length === 0) {
                callback(new Error('请至少添加一条可提现规则'))
                return
              }
              const invalid = value.some((it) => {
                if (!it) return true
                const dayInvalid = it.many_day === '' || it.many_day === null || it.many_day === undefined || Number(it.many_day) < 1
                const numInvalid = it.many_day_number === '' || it.many_day_number === null || it.many_day_number === undefined || Number(it.many_day_number) < 1
                const amountNum = Number(it.withdrawal_amount)
                const amountInvalid = it.withdrawal_amount === '' || it.withdrawal_amount === null || it.withdrawal_amount === undefined || Number.isNaN(amountNum) || amountNum < 0 || !Number.isInteger(amountNum)
                return dayInvalid || numInvalid || amountInvalid
              })
              if (invalid) {
                callback(new Error('可提现规则中天数/次数必填且>=1，提现金额必填且为非负整数'))
                return
              }
              callback()
            },
            trigger: 'change'
          }
        ]
      }
    }
  },
  methods: {
    open(row) {
      this.resetForm()
      this.isEdit = !!row && row.id != null
      if (this.isEdit && row) {
        this.editId = row.id
        this.wechatid = row.app_id
        this.wechatname = row.account_name
        this.form.title = row.title || ''
        const cfg = row.config_result || {}
        this.form.config_result = {
          coin: cfg.coin ?? 10,
          decrease_start: cfg.decrease_start ?? 10,
          decrease_end: cfg.decrease_end ?? 20,
          // 后端是分，这里转成元展示
          exchange_rate: cfg.exchange_rate,
          withdrawal_rules: Array.isArray(cfg.withdrawal_rules) && cfg.withdrawal_rules.length
            ? cfg.withdrawal_rules.map((it) => ({
              many_day: it.many_day ?? 7,
              many_day_number: it.many_day_number ?? 1,
              withdrawal_amount: it.withdrawal_amount != null ? it.withdrawal_amount / 100 : 1
            }))
            : [{ many_day: 7, many_day_number: 1, withdrawal_amount: 1 }]
        }
      }
      this.visible = true
    },
    yuanDisplay(val) {
      if (val == null || val === '') return '-'
      return Number(val).toFixed(2)
    },
    addWithdrawalRule() {
      this.form.config_result.withdrawal_rules.push({ many_day: 7, many_day_number: 1, withdrawal_amount: 0 })
    },
    removeWithdrawalRule(index) {
      if (this.form.config_result.withdrawal_rules.length <= 1) return
      this.form.config_result.withdrawal_rules.splice(index, 1)
    },
    resetForm() {
      this.isEdit = false
      this.editId = null
      this.wechatid = null
      this.wechatname = ''
      this.form = {
        title: '',
        config_result: {
          coin: 10,
          decrease_start: 10,
          decrease_end: 20,
          exchange_rate: 1000,
          withdrawal_rules: [
            { many_day: 7, many_day_number: 1, withdrawal_amount: 1 }
          ]
        }
      }
      this.$refs.form && this.$refs.form.clearValidate()
    },
    handleClose() {
      this.resetForm()
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        const toFen = v => Math.round(Number(v || 0) * 100)
        const config_result = {
          coin: Number(this.form.config_result.coin),
          decrease_start: Number(this.form.config_result.decrease_start),
          decrease_end: Number(this.form.config_result.decrease_end),
          // 金额相关字段：前端填写的是元，这里统一转换为分传给后端
          exchange_rate: Number(this.form.config_result.exchange_rate),
          withdrawal_rules: this.form.config_result.withdrawal_rules.map((it) => ({
            many_day: Number(it.many_day),
            many_day_number: Number(it.many_day_number),
            withdrawal_amount: toFen(it.withdrawal_amount)
          }))
        }
        // 新增时必须选择小程序，编辑时不允许修改 app_id，也无需再传给后端
        if (!this.isEdit && !this.wechatid) {
          this.$message.error('请选择小程序')
          return
        }
        const payload = this.isEdit
          ? { id: this.editId, title: this.form.title, config_result }
          : {
            app_id: this.wechatid,
            title: this.form.title,
            config_result
          }
        this.submitting = true
        const request = this.isEdit ? adRedPacketWithdrawConfigUpdate(payload) : adRedPacketWithdrawConfigCreate(payload)
        request
          .then(() => {
            this.$message.success(this.isEdit ? '更新成功' : '创建成功')
            this.visible = false
            this.$emit('success')
          })
          .finally(() => {
            this.submitting = false
          })
      })
    },
    choosewecaht() {
      this.dialogVisiblewechat = true
      this.$nextTick(() => {
        this.$refs.chhosewecahtr.send()
      })
    },
    callback(item) {
      this.dialogVisiblewechat = false
      this.wechatname = item.account_name
      this.wechatid = item.app_id
      console.log('item', item)
    }
  }
}
</script>

<style scoped>
.unit-tip {
  margin-left: 8px;
  color: #909399;
  font-size: 12px;
}
.withdrawal-list {
  margin-bottom: 8px;
}
.withdrawal-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.withdrawal-rule-item {
  margin-bottom: 8px;
}
.withdrawal-rule-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.rule-label {
  color: #606266;
  font-size: 12px;
}
.withdrawal-item .unit-tip {
  margin-left: 8px;
  min-width: 60px;
}
.withdrawal-item .el-button {
  margin-left: 8px;
}
</style>
